// extracted by mini-css-extract-plugin
export var baseButton = "_q2-0";
export var controlsArrowKeys = "_q2-1";
export var controlsResetButton = "_q2-2";
export var lightGameButton = "_q2-4 _q2-0";
export var playAgainButton = "_q2-5 _q2-0";
export var startGameButton = "_q2-3 _q2-0";